import getResource from './get-resource';
import jsonFetch from '@cube/utils/lib/json-fetch';

// 5 minute cache age.
const MAX_AGE = 5 * 60 * 1000;

let apiURL = null;

function validateApiURL() {
	if (!apiURL || !apiURL.length) { apiURLError(); }
}

function apiURLError() {
	let err = `LocationAPI ERROR: Invalid apiURL: ${apiURL}`;
	if (process.env.NODE_ENV !== 'production') {
		throw new Error(err);
	}
	else {
		console.error(err);
	}
}

export function setAPIOrigin(url) {
	if (url && url.charAt(url.length - 1) === '/') {
		url = url.substr(0, url.length - 1);
	}
	apiURL = url;
	validateApiURL();
}

export function fetchGeoLocation() {
	validateApiURL();
	return jsonFetch(`${apiURL}/ip/?fields=verbose`, {}, MAX_AGE);
}

export function search(query, international) {
	validateApiURL();
	return getResource(apiURL, query, international).then(url => jsonFetch(url, {}, MAX_AGE));
}

export function fetchGeonames(geonames) {
	validateApiURL();
	return jsonFetch(`${apiURL}/search/?geoname_id=${geonames.join('&geoname_id=')}&fields=verbose`, {}, MAX_AGE);
}
